import { Mask } from "./Mask";
import { masks } from "./masks";

export class CardNumberMask implements Mask {
  searchValue = masks.card_number.searchValue;
  replaceValue = masks.card_number.replaceValue;
  maxLength = 16;

  execute(value: string): string {
    const numericValue = value.replace(/\D/g, "");
    const limitedValue = numericValue.substring(0, this.maxLength);

    if (limitedValue.length === this.maxLength) {
      return this.format(limitedValue);
    }

    return limitedValue;
  }

  format(value: string): string {
    return value.replace(this.searchValue, this.replaceValue).trim();
  }
}
